import { useGeolocation } from 'providers'
import { parseLatLng } from './panel-config'

// Coordinates for a panel: manual `location` from its config when useGeolocation is off,
// otherwise the device position. Returns primitives so callers can use them as effect deps.
export const usePanelLocation = (config) => {
  const { position } = useGeolocation()
  const manual = config?.useGeolocation ? null : parseLatLng(config?.location)
  const geo = manual || position
  return { latitude: geo?.latitude, longitude: geo?.longitude }
}
